import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
const initialState = {
  assessment_answers: [],
  selectedTab: "this_month",
  assessment_question_type:"",
  selectedGroupType:"",
  selectedAgeResponse:{},
  selectedGuestUUID:"",
  selectedOptionResponse:{},
  selectedLanguage:"",
  selectedLangResponse:{},
  guestScoreDetails:{},
  headingQuestionType:""
};

const assessmentReducer = createSlice({
  name: "assessmentReducer",
  initialState,
  reducers: {
    setAssessmentAnswer(state, action) {
      state.assessment_answers = action.payload;
    },
    setAssessmentQuestionType(state, action){
      state.assessment_question_type=action.payload;
    },
    setSelectedTab(state, action) {
      state.selectedTab = action.payload;
    },
    setSelectedAgeGroup(state,action){
      state.selectedGroupType=action.payload;
    },
    resetAssessment(state,action){
      state.assessment_answers= [];
      state.selectedTab= "this_month";
      state.assessment_question_type ="";
      state.selectedGroupType = "";
    },
    setAgeResponse(state,action){
      state.selectedAgeResponse=action.payload;
    },
    setGuestUUID(state,action){
      state.selectedGuestUUID=action.payload;
    },
    setOptionResponse(state,action){
      state.selectedOptionResponse=action.payload;
    },
    setSelectedLang(state,action){
      state.selectedLanguage=action.payload;
    },
    setSelectedLangResponse(state,action){
      state.selectedLangResponse=action.payload;
    },
    resetFunnelingData(state,action){
      state.selectedLanguage="";
      state.selectedGuestUUID="";
      state.selectedAgeResponse={};
      state.selectedOptionResponse={};
      state.assessment_question_type ="";
      state.assessment_answers= [];
      state.selectedGroupType = "";
    },
    setGuestScoreDetails(state,action){
      state.guestScoreDetails=action.payload;
    },
    setHeadingQuestionType(state,action){
      state.headingQuestionType=action.payload
    }
  },
});
export const { setAssessmentAnswer, setSelectedTab, setAssessmentQuestionType, 
  setSelectedAgeGroup, resetAssessment,setAgeResponse,setSelectedLangResponse,setGuestScoreDetails,
  setGuestUUID,setOptionResponse,setSelectedLang,resetFunnelingData,setHeadingQuestionType} = assessmentReducer.actions;
export default assessmentReducer.reducer;
